var map = {
	"./Alchimeia_closed.png": "./src/assets/img/progress/islands/Alchimeia_closed.png",
	"./Fabella_closed.png": "./src/assets/img/progress/islands/Fabella_closed.png",
	"./Lumina_closed.png": "./src/assets/img/progress/islands/Lumina_closed.png",
	"./Morbida_closed.png": "./src/assets/img/progress/islands/Morbida_closed.png",
	"./Oracle_closed.png": "./src/assets/img/progress/islands/Oracle_closed.png",
	"./Sylva_closed.png": "./src/assets/img/progress/islands/Sylva_closed.png",
	"./Temperus_closed.png": "./src/assets/img/progress/islands/Temperus_closed.png",
	"./Veritas_closed.png": "./src/assets/img/progress/islands/Veritas_closed.png",
	"./chance_closed.png": "./src/assets/img/progress/islands/chance_closed.png",
	"./judgement_closed.png": "./src/assets/img/progress/islands/judgement_closed.png",
	"./solace_closed.png": "./src/assets/img/progress/islands/solace_closed.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/progress/islands sync recursive ^\\.\\/.*_closed\\.png$";